import { render, staticRenderFns } from "./callingpatterns.vue?vue&type=template&id=05d5c53d"
import script from "./callingpatterns.vue?vue&type=script&lang=js"
export * from "./callingpatterns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports